import { render, staticRenderFns } from "./schoolyearForm.vue?vue&type=template&id=605cfed4&"
import script from "./schoolyearForm.vue?vue&type=script&lang=js&"
export * from "./schoolyearForm.vue?vue&type=script&lang=js&"
import style0 from "./schoolyearForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports